var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6673 6.99967C13.6673 10.6816 10.6825 13.6663 7.00065 13.6663C3.31875 13.6663 0.333984 10.6816 0.333984 6.99967C0.333984 3.31778 3.31875 0.333008 7.00065 0.333008C10.6825 0.333008 13.6673 3.31778 13.6673 6.99967ZM7.00065 6.33301C7.36884 6.33301 7.66732 6.63148 7.66732 6.99967V10.3336C7.66732 10.7018 7.36884 11.0003 7.00065 11.0003C6.63246 11.0003 6.33398 10.7018 6.33398 10.3336V6.99967C6.33398 6.63148 6.63246 6.33301 7.00065 6.33301ZM7.00065 4.99967C7.36884 4.99967 7.66732 4.7012 7.66732 4.33301C7.66732 3.96482 7.36884 3.66634 7.00065 3.66634C6.63246 3.66634 6.33398 3.96482 6.33398 4.33301C6.33398 4.7012 6.63246 4.99967 7.00065 4.99967Z",
    fill: "#9A9FA5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLight);
export default __webpack_public_path__ + "static/media/info_light.e7bb6b5d1917be8afd5c7c164992fa71.svg";
export { ForwardRef as ReactComponent };